import { Color, DoubleSide, BufferGeometry, Line, LineBasicMaterial, Mesh, MeshBasicMaterial, PlaneGeometry, Vector2, Vector3, } from "three";
import { SceneGraphNode } from "../internal";
export class FrameFeatureBox extends SceneGraphNode {
    constructor(nx, ny, w, h) {
        super(null);
        this._x = -1;
        this._y = -1;
        this._w = -1;
        this._h = -1;
        this._x = nx;
        this._y = ny;
        this._w = w;
        this._h = h;
        this._originalColor = new Color(parseInt("0xff0000"));
        this._highlightColor = new Color(parseInt("0x00ff00"));
        this.tMaterial = new MeshBasicMaterial({
            transparent: true,
            color: this._originalColor,
            opacity: 0.2,
            side: DoubleSide,
        });
        this.iMesh = new Mesh(new PlaneGeometry(1, 1, 1, 1), this.tMaterial);
        const borderGeometry = new BufferGeometry();
        borderGeometry.setFromPoints([
            new Vector3(-0.5, 0.5, 0),
            new Vector3(0.5, 0.5, 0),
            new Vector3(0.5, -0.5, 0),
            new Vector3(-0.5, -0.5, 0),
            new Vector3(-0.5, 0.5, 0),
        ]);
        borderGeometry.computeBoundingSphere();
        const borderMaterial = new LineBasicMaterial({
            transparent: true,
            color: 0xff0000,
            opacity: 1.0,
            side: DoubleSide,
        });
        this.iBorder = new Line(borderGeometry, borderMaterial);
    }
    //todo: how could this now work in the new three.js version
    render(traversalState) {
        super.render(traversalState);
        this.currentTraversalState = traversalState;
        if (this.iMesh != null) {
            const mousecoord_xy = traversalState.actualQuadtree.mapToMouse(this._x, this._y);
            const x = mousecoord_xy[0];
            const y = mousecoord_xy[1];
            const mousecoord_wh = traversalState.actualQuadtree.mapToMouse(this._x + this._w, this._y + this._h);
            const w = mousecoord_wh[0] - x + 0.5;
            const h = mousecoord_wh[1] - y + 0.5;
            this.iMesh.position.set(-traversalState.scene.engine.getContextWidth() / 2 + x + w / 2, traversalState.scene.engine.getContextHeight() / 2 - y - h / 2, 50);
            this.iMesh.scale.set(w, -h, 1);
            this.iBorder.position.set(-traversalState.scene.engine.getContextWidth() / 2 + x + w / 2, traversalState.scene.engine.getContextHeight() / 2 - y - h / 2, 50);
            this.iBorder.scale.set(w, -h, 1);
        }
    }
    /**
     * @description resize/reposition box by given size and new anchorpoint
     * @param nx
     * @param ny
     * @param w
     * @param h
     */
    resize(nx, ny, w, h) {
        this._x = nx;
        this._y = ny;
        this._w = w;
        this._h = h;
        this.update();
    }
    destroy() {
        this.tMaterial = null;
        this.iMesh = null;
        this.iBorder = null;
        this._x = null;
        this._y = null;
        this._w = null;
        this._h = null;
    }
    show() {
        this.iMesh.visible = true;
        this.iBorder.visible = true;
    }
    hide() {
        this.iMesh.visible = false;
        this.iBorder.visible = false;
    }
    isVisible() {
        return this.iMesh.visible;
    }
    /**
     * @description check if this is covering mx,my pos
     * @param mx
     * @param my
     * @returns {any}
     */
    pick(mx, my) {
        if (this.initialized)
            return this.currentTraversalState.rayCasterQuadtreeScene.intersectObject(this.iMesh);
        return [];
    }
    highlightOn() {
        this.tMaterial["color"] = this._highlightColor;
    }
    highlightOff() {
        this.tMaterial["color"] = this._originalColor;
    }
    //todo: how could this now work in the new three.js version
    update() {
        this.position = new Vector2(this._x, this._y);
        this.size = new Vector2(this._w, this._h);
    }
    updateStyle(matdef) {
        if (matdef["polygon"]["fill"]) {
            if (matdef["polygon"]["fill"]["color"]) {
                this._originalColor = new Color(matdef["polygon"]["fill"]["color"]);
                this.tMaterial["color"] = this._originalColor;
            }
            if (matdef["polygon"]["fill"]["alpha"])
                this.tMaterial["opacity"] = matdef["polygon"]["fill"]["alpha"];
        }
        if (matdef["polygon"]["stroke"]) {
            if (matdef["polygon"]["stroke"]["color"]) {
                this.iBorder.material["color"] = new Color(matdef["polygon"]["stroke"]["color"]);
            }
            if (matdef["polygon"]["stroke"]["alpha"]) {
                this.iBorder.material["opacity"] = matdef["polygon"]["stroke"]["alpha"];
            }
            if (matdef["polygon"]["stroke"]["width"]) {
                this.iBorder.material["linewidth"] = matdef["polygon"]["stroke"]["width"];
            }
        }
        if (matdef["line"]["stroke"]) {
            if (matdef["line"]["stroke"]["color"]) {
                this.iBorder.material["color"] = new Color(matdef["line"]["stroke"]["color"]);
            }
            if (matdef["line"]["stroke"]["alpha"]) {
                this.iBorder.material["opacity"] = matdef["line"]["stroke"]["alpha"];
            }
            if (matdef["line"]["stroke"]["width"]) {
                this.iBorder.material["linewidth"] = matdef["line"]["stroke"]["width"];
            }
        }
    }
}
//# sourceMappingURL=framefeaturebox.js.map